import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_condRenovac.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	recuperar(p_email, p_usuario, p_ejecutivo, p_anno, p_poliza, p_corredor, p_producto){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_condRenovac.recuperar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_ejecutivo": p_ejecutivo,
				"p_anno": p_anno,
				"p_poliza": p_poliza,
				"p_corredor": p_corredor,
				"p_producto": p_producto
				})
		})
	},

	fnc_actualiza(p_email, p_usuario, p_ejecutivo, p_anno, p_poliza, 
		p_estadocomercial, p_comentario,  p_fechaenvpro, p_fecharecepcion, p_mtoaserenmonpol, p_tasalin1ren){
			return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_condRenovac.fnc_actualiza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo,
					"p_anno": p_anno,
					"p_poliza": p_poliza,
					"p_estadocomercial": p_estadocomercial,
					"p_comentario": p_comentario,
					"p_fechaenvpro": p_fechaenvpro,
					"p_fecharecepcion": p_fecharecepcion,
					"p_mtoaserenmonpol": p_mtoaserenmonpol,
                    "p_tasalin1ren": p_tasalin1ren
					
					})
			});
		},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gestRenovac.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},

}